import TileLayer from 'ol/layer/Tile'
import { fromLonLat } from 'ol/proj'
import TileWMS from 'ol/source/TileWMS'
import {
  MAP_PROJECTION,
  OPEN_LAYERS_LOT_BOUNDARIES_LAYER_NAME,
  OPEN_LAYERS_LOT_BOUNDARIES_URL,
  OPEN_LAYERS_MAPPROXY_OSM_LAYER_NAME,
  OPEN_LAYERS_MAPPROXY_OSM_URL,
} from '../../environment'

export const INITIAL_POS = fromLonLat([133.349051, -20.395616])
export const DEFAULT_ZOOM_LEVEL = 5.7
export const ZOOM_TO_ZOOM_LEVEL = 17

export const lotBoundaryWmsSource = new TileWMS({
  url: OPEN_LAYERS_LOT_BOUNDARIES_URL,
  params: { 'LAYERS': OPEN_LAYERS_LOT_BOUNDARIES_LAYER_NAME, 'TILED': true, 'srs': MAP_PROJECTION },
  serverType: 'geoserver',
  projection: MAP_PROJECTION,
  transition: 0,
})

export const lotBoundaryLayer = new TileLayer({
  className: 'cadastre-layer',
  source: lotBoundaryWmsSource,
})

// When on non-standard browser zoom, this layer
// may produce unexpected borders between loaded sections.
export const mapproxyOSMLayer = new TileLayer({
  source: new TileWMS({
    url: OPEN_LAYERS_MAPPROXY_OSM_URL,
    params: { 'LAYERS': OPEN_LAYERS_MAPPROXY_OSM_LAYER_NAME },
    serverType: 'geoserver',
    hidpi: false,
    projection: MAP_PROJECTION,
    // Countries have transparency, so do not fade tiles:
    transition: 0,
  }),
})

export const DEFAULT_LAYERS = [mapproxyOSMLayer, lotBoundaryLayer]